<template>
  <div class="align-items-center justify-content-center" style="display: flex">
    <div v-if="!registrationStatusLoaded"></div>
    <div v-else-if="registrationClosed" class="flex flex-column align-items-center">
      <h3>{{ registrationClosedMessage }}</h3>
    </div>
    <div v-else-if="!noBotCheckPassed">
      <h3>Bitte zunächst bestätigen, dass Sie ein Mensch sind</h3>
      <h4>Wie checked man {{ noBotCheckNumber }} ?</h4>
      <h4 style="color: red" v-if="noBotCheckError && noBotCheckError.length > 0">
        {{ noBotCheckError }}
      </h4>
      <InputText v-model="noBotCheckValue" style="margin: 2px 5px" />
      <Button
        v-if="noBotCheckValue && noBotCheckValue.length > 0"
        label="Prüfen"
        @click="checkNotBotCheck"
        style="margin: 2px 5px"
      />
      <Button v-else label="Prüfen" style="margin: 2px 5px" disabled />
      <h4 style="margin: 16px 0px 6px 0px">Schreibweisen</h4>

      <div class="flex flex-column align-items-center justify-content-center">
        <div>T20 = Triple 20</div>
        <div>D19 = Double 19</div>
        <div>S18 = einfache 18</div>
        <div>B = Single Bull</div>
        <div>DB = Double Bull</div>
        <div style="margin-top: 8px">T20D20 wäre beispielsweise ein Check für 100</div>
      </div>
    </div>
    <div v-else-if="registrationSubmitted" class="flex flex-column align-items-center">
      <h3>Vielen Dank, die Anmeldung wurde gespeichert.</h3>
      <Button
        label="Weitere Mannschaft anmelden"
        icon="pi pi-plus"
        @click="resetRegistration"
        style="margin-top: 16px"
      />
    </div>
    <div v-else-if="!entryChoiceMade" class="flex flex-column align-items-center">
      <h3 style="margin-bottom: 6px">Angefangene Anmeldung fortsetzen</h3>
      <h4
        style="color: red"
        v-if="resumeError && resumeError.length > 0"
      >
        {{ resumeError }}
      </h4>
      <div class="flex align-items-center justify-content-center" style="gap: 5px">
        <InputText
          v-model="resumeIdInput"
          placeholder="z.B. BDLR-K7Q4"
          style="text-transform: uppercase; width: 200px"
          :disabled="wizardBusy"
          @keyup.enter="resumeIdInput && loadDraft()"
        />
        <Button
          label="Fortsetzen"
          icon="pi pi-arrow-right"
          iconPos="right"
          :disabled="!resumeIdInput || resumeIdInput.length === 0 || wizardBusy"
          @click="loadDraft"
        />
      </div>
      <h3 style="margin-top: 28px; margin-bottom: 6px">Oder neue Anmeldung starten</h3>
      <h4
        style="color: red"
        v-if="entryError && entryError.length > 0"
      >
        {{ entryError }}
      </h4>
      <Button
        label="Neue Anmeldung starten"
        icon="pi pi-plus"
        style="max-width: 280px"
        :disabled="wizardBusy"
        @click="startNewRegistration"
      />
    </div>
    <div v-else style="width: 100%; max-width: 800px; min-width: 320px">
      <Message
        v-if="draftId"
        severity="info"
        :closable="false"
        style="max-width: 600px; margin: 0 auto 12px"
      >
        Ihre Anmeldungs-ID: <strong>{{ draftId }}</strong>
        <Button
          icon="pi pi-copy"
          v-tooltip.top="'In Zwischenablage kopieren'"
          severity="secondary"
          text
          rounded
          style="width: 1.8rem; height: 1.8rem; margin-left: 4px"
          @click="copyDraftId"
        />
        — bitte notieren, um die Anmeldung später fortzusetzen. Die ID ist 30 Tage
        gültig.
      </Message>
      <Stepper v-model:activeStep="activeStep">
        <StepperPanel>
          <template #header="{ index, clickCallback }">
            <button
              class="p-stepper-action custom-stepper-class"
              role="tab"
              @click="navigateStep(index, clickCallback)"
            >
              <div class="flex flex-column align-items-center justify-content-center">
                <span
                  class="p-stepper-number"
                  style="width: 2rem"
                  data-pc-section="number"
                  >{{ index + 1 }}</span
                ><span class="p-stepper-title" data-pc-section="title">Verein</span>
              </div>
            </button>
          </template>
          <template #content="{ nextCallback }">
            <div v-if="teamRegistrationError && teamRegistrationError.length > 0">
              <h4 style="color: red; margin: 10px">
                {{ teamRegistrationError }}
              </h4>
            </div>
            <div class="flex flex-column align-items-center">
              <Dropdown
                id="association"
                v-model="selectedAssociation"
                :options="associations"
                optionLabel="name"
                dataKey="id"
                placeholder="Bitte Verein auswählen"
                style="width: 80%"
                :editable="false"
                :filter="true"
                @change="onAssociationChange"
              />
              <div
                v-if="selectedAssociation && selectedAssociation.id && !associationUnlocked"
                class="flex flex-column align-items-center"
                style="margin-top: 20px; width: 100%; max-width: 600px"
              >
                <Message severity="info" :closable="false"
                  >Sie können die Mannschaft direkt melden – die hinterlegten
                  Vereinsdaten werden dabei unverändert übernommen, eine Eingabe der
                  BWDV-Nummer ist dafür nicht nötig.<br /><br />
                  Nur wenn Sie die <strong>Vereinsdaten ändern</strong> möchten (z.B.
                  Adresse oder Vorstand), schalten Sie diese zum Schutz vor
                  unbefugten Änderungen zunächst mit der korrekten BWDV-Nummer
                  (Vereinsnummer) des Vereins frei.</Message
                >
                <div class="field grid" style="margin-top: 15px; width: 100%">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >BWDV-Nummer</label
                  >
                  <div class="col">
                    <InputText
                      v-model="bwdvNumberInput"
                      class="bdl-input"
                      placeholder="Nur zum Bearbeiten der Vereinsdaten nötig"
                      :disabled="wizardBusy"
                      @keyup.enter="unlockAssociation"
                    />
                  </div>
                </div>
                <div
                  v-if="associationUnlockError && associationUnlockError.length > 0"
                  style="color: red; margin-bottom: 10px"
                >
                  {{ associationUnlockError }}
                </div>
                <Button
                  label="Vereinsdaten zum Bearbeiten freischalten"
                  icon="pi pi-lock-open"
                  severity="secondary"
                  :disabled="wizardBusy || !bwdvNumberInput"
                  @click="unlockAssociation"
                />
              </div>
              <div
                v-if="selectedAssociation && selectedAssociation.id && associationUnlocked"
                style="margin-top: 20px; width: 100%"
              >
                <div>
                  <h3>
                    Bitte die folgenden Angaben auf Vollständigkeit und Richtigkeit prüfen
                    und, falls nötig, ergänzen oder anpassen!
                  </h3>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >BWDV-Nummer</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.bwdvNumber"
                      class="bdl-input"
                      disabled
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >Name</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.name"
                      class="bdl-input"
                      disabled
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >Mitgliedsnr. Sportbund</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.sportbundNumber"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >Vorstand*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.chairmanName"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >Strasse*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.street"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >PLZ*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.plz"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >Stadt*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.city"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 180px"
                    >E-Mail*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedAssociation.email"
                      class="bdl-input"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="flex pt-4 justify-content-end">
              <Button
                label="Weiter"
                icon="pi pi-arrow-right"
                iconPos="right"
                :disabled="wizardBusy"
                @click="stepIsValid(nextCallback)"
              />
            </div>
          </template>
        </StepperPanel>
        <StepperPanel header="Mannschaft">
          <template #header="{ index, clickCallback }">
            <button
              class="p-stepper-action custom-stepper-class"
              role="tab"
              @click="navigateStep(index, clickCallback)"
            >
              <div class="flex flex-column align-items-center justify-content-center">
                <span
                  class="p-stepper-number"
                  style="width: 2rem"
                  data-pc-section="number"
                  >{{ index + 1 }}</span
                ><span class="p-stepper-title" data-pc-section="title">Mannschaft</span>
              </div>
            </button>
          </template>
          <template #content="{ prevCallback, nextCallback }">
            <div v-if="teamRegistrationError && teamRegistrationError.length > 0">
              <h3 style="color: red; margin: 10px">{{ teamRegistrationError }}</h3>
            </div>
            <div v-if="!newOrOldTeamSelected">
              <div>
                <h3>Welche Mannschaft möchten Sie melden?</h3>
                <Button
                  label="Eine bereits existierende Mannschaft"
                  style="margin: 10px; max-width: 250px"
                  @click="
                    newOrOldTeamSelected = true;
                    newTeam = false;
                    selectedTeam = {};
                  "
                />
                <Button
                  label="Eine komplett neue Mannschaft"
                  style="margin: 10px; max-width: 250px"
                  @click="
                    newOrOldTeamSelected = true;
                    newTeam = true;
                    selectedTeam = {};
                  "
                />
              </div>
              <div class="flex justify-content-center flex-wrap">
                <Message severity="info" :closable="false" style="max-width: 600px"
                  >Bei einer existierenden Mannschaft muss es sich um eine Mannschaft
                  handeln, die in der vorhergehenden Saison gemeldet war. Für diese
                  Mannschaft wird der Liga-Status übernommen.<br />
                  Die Auswahl kann über den unteren Button "Auswahl zurücksetzen" erneut
                  getroffen werden</Message
                >
              </div>
            </div>
            <div v-else>
              <Dropdown
                v-if="!newTeam"
                v-model="selectedTeam"
                :options="teams"
                optionLabel="name"
                dataKey="id"
                placeholder="Bitte eine Mannschaft auswählen"
                style="width: 80%"
                :editable="false"
                :filter="true"
              />
              <div
                v-if="newTeam || (selectedTeam && selectedTeam.name)"
                style="margin-top: 20px"
              >
                <div>
                  <h3 v-if="newTeam">Bitte alle Felder ausfüllen!</h3>
                  <h3 v-else>
                    Bitte die folgenden Angaben auf Vollständigkeit und Richtigkeit prüfen
                    und, falls nötig, ergänzen oder anpassen!
                  </h3>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Name*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedTeam.name"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Name Teamvertreter*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedTeam.contactPersonName"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >E-Mail Teamvertreter*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedTeam.contactPersonEMail"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Telefonnummer Teamvertreter*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedTeam.contactPersonPhone"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Pokal-Teilnahme*</label
                  >
                  <div class="col">
                    <SelectButton
                      v-model="selectedTeam.registeredForCup"
                      :options="booleanOptions"
                      optionLabel="name"
                      optionValue="value"
                      :disabled="wizardBusy"
                      style="text-align: left"
                    >
                    </SelectButton>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex pt-4 justify-content-between">
              <Button
                label="Zurück"
                severity="secondary"
                icon="pi pi-arrow-left"
                @click="prevCallback"
              />
              <Button
                label="Auswahl zurücksetzen"
                severity="secondary"
                icon="pi pi-undo"
                @click="
                  newOrOldTeamSelected = false;
                  newTeam = false;
                  selectedTeam = {};
                "
              />
              <Button
                label="Weiter"
                icon="pi pi-arrow-right"
                iconPos="right"
                :disabled="wizardBusy"
                @click="stepIsValid(nextCallback)"
              />
            </div>
          </template>
        </StepperPanel>
        <StepperPanel header="Spielstätte">
          <template #header="{ index, clickCallback }">
            <button
              class="p-stepper-action custom-stepper-class"
              role="tab"
              @click="navigateStep(index, clickCallback)"
            >
              <div class="flex flex-column align-items-center justify-content-center">
                <span
                  class="p-stepper-number"
                  style="width: 2rem"
                  data-pc-section="number"
                  >{{ index + 1 }}</span
                ><span class="p-stepper-title" data-pc-section="title">Spielstätte</span>
              </div>
            </button>
          </template>
          <template #content="{ prevCallback, nextCallback }">
            <div v-if="teamRegistrationError && teamRegistrationError.length > 0">
              <h3 style="color: red; margin: 10px">{{ teamRegistrationError }}</h3>
            </div>
            <div v-if="!newOrOldLocationSelected">
              <div>
                <h3>Welche Spielstätte möchten Sie wählen?</h3>
                <Button
                  label="Eine bereits existierende Spielstätte"
                  style="margin: 10px; max-width: 250px"
                  @click="
                    newOrOldLocationSelected = true;
                    newLocation = false;
                    selectedLocation =
                      selectedTeam.location && selectedTeam.location.name
                        ? { ...selectedTeam.location }
                        : {};
                  "
                />
                <Button
                  label="Eine komplett neue Spielstätte"
                  style="margin: 10px; max-width: 250px"
                  @click="
                    newOrOldLocationSelected = true;
                    newLocation = true;
                    selectedLocation = {};
                  "
                />
              </div>
              <div class="flex justify-content-center flex-wrap">
                <Message severity="info" :closable="false" style="max-width: 600px"
                  >In einer existierenden Spielstätte wurde in der vorhergehenden Saison
                  bereits gespielt.<br />
                  Im Zweifel eine existierende Spielstätte auswählen und bei Bedarf die
                  Auswahl über den unteren Button "Auswahl zurücksetzen" erneut
                  treffen.</Message
                >
              </div>
            </div>
            <div v-else>
              <Dropdown
                v-if="!newLocation"
                v-model="selectedLocation"
                :options="locations"
                :filterFields="['name', 'street', 'plz', 'city']"
                dataKey="id"
                placeholder="Bitte eine Spielstätte auswählen"
                style="width: 80%"
                :editable="false"
                :filter="true"
              >
                <template #value="slotProps">
                  <div class="flex justify-content-center align-items-center">
                    <div v-if="slotProps.value.name && slotProps.value.name.length > 0">
                      {{ slotProps.value.name }} ({{ slotProps.value.street }},
                      {{ slotProps.value.plz }} {{ slotProps.value.city }})
                    </div>
                    <div v-else>{{ slotProps.placeholder }}</div>
                  </div>
                </template>
                <template #option="slotProps">
                  <div class="flex justify-content-center align-items-center">
                    <div>
                      {{ slotProps.option.name }} ({{ slotProps.option.street }},
                      {{ slotProps.option.plz }} {{ slotProps.option.city }})
                    </div>
                  </div>
                </template>
              </Dropdown>
              <div
                v-if="newLocation || (selectedLocation && selectedLocation.name)"
                style="margin-top: 20px"
              >
                <div>
                  <h3 v-if="newTeam">Bitte alle Felder ausfüllen!</h3>
                  <h3 v-else>
                    Bitte die folgenden Angaben auf Vollständigkeit und Richtigkeit prüfen
                    und, falls nötig, ergänzen oder anpassen!
                  </h3>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Name*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedLocation.name"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Straße und Hausnummer*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedLocation.street"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >PLZ*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedLocation.plz"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Stadt*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedLocation.city"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Anzahl Boards*</label
                  >
                  <div class="col">
                    <InputText
                      v-model="selectedLocation.numberOfBoards"
                      class="bdl-input"
                    />
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Rauchen*</label
                  >
                  <div class="col">
                    <SelectButton
                      v-model="selectedLocation.smokingType"
                      :options="smokingOptions"
                      optionLabel="name"
                      optionValue="value"
                      :disabled="wizardBusy"
                      style="text-align: left"
                    >
                    </SelectButton>
                  </div>
                </div>
                <div class="field grid">
                  <label class="col-fixed custom-input-label" style="width: 300px"
                    >Jugend erlaubt*</label
                  >
                  <div class="col">
                    <SelectButton
                      v-model="selectedLocation.youthAllowed"
                      :options="booleanOptions"
                      optionLabel="name"
                      optionValue="value"
                      :disabled="wizardBusy"
                      style="text-align: left"
                    >
                    </SelectButton>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex pt-4 justify-content-between">
              <Button
                label="Zurück"
                severity="secondary"
                icon="pi pi-arrow-left"
                @click="prevCallback"
              />
              <Button
                label="Auswahl zurücksetzen"
                severity="secondary"
                icon="pi pi-undo"
                @click="
                  newOrOldLocationSelected = false;
                  newLocation = false;
                  selectedLocation = {};
                "
              />
              <Button
                label="Weiter"
                icon="pi pi-arrow-right"
                iconPos="right"
                :disabled="wizardBusy"
                @click="stepIsValid(nextCallback)"
              />
            </div>
          </template>
        </StepperPanel>
        <StepperPanel header="Wünsche">
          <template #header="{ index, clickCallback }">
            <button
              class="p-stepper-action custom-stepper-class"
              role="tab"
              @click="navigateStep(index, clickCallback)"
            >
              <div class="flex flex-column align-items-center justify-content-center">
                <span
                  class="p-stepper-number"
                  style="width: 2rem"
                  data-pc-section="number"
                  >{{ index + 1 }}</span
                ><span class="p-stepper-title" data-pc-section="title">Wünsche</span>
              </div>
            </button>
          </template>

          <template #content="{ prevCallback, nextCallback }">
            <div v-if="teamRegistrationError && teamRegistrationError.length > 0">
              <h3 style="color: red; margin: 10px">{{ teamRegistrationError }}</h3>
            </div>
            <div class="flex justify-content-center" style="margin: 10px 0">
              <Button
                label="Bedingung oder Wunsch hinzufügen"
                icon="pi pi-plus"
                @click="addCriteria"
              />
            </div>
            <DataTable
              class="p-datatable-sm"
              :value="teamCriterias"
              stripedRows
              responsiveLayout="stack"
              breakpoint="550px"
              style="margin-top: 15px; width: 100%"
            >
              <template #empty>
                <div style="text-align: center; padding: 10px; color: #6c757d">
                  Noch keine Wünsche oder Bedingungen erfasst.
                </div>
              </template>
              <Column field="type" header="Art">
                <template #body="{ data }">
                  <span>{{ getLabelForCriteriaType(data) }}</span>
                </template>
              </Column>
              <Column header="Aktionen">
                <template #body="slotProps">
                  <Button
                    style="margin: 2px 2px"
                    icon="pi pi-pencil"
                    v-tooltip.top="'Editieren'"
                    class="p-button-rounded p-button-success mb2"
                    @click="editCriteria(slotProps.data)"
                  />
                  <Button
                    style="margin: 2px 2px"
                    icon="pi pi-trash"
                    v-tooltip.top="'Löschen'"
                    class="p-button-rounded p-button-warning"
                    @click="deleteCriteria(slotProps.data)"
                  />
                </template>
              </Column>
            </DataTable>
            <div class="flex pt-4 justify-content-between">
              <Button
                label="Zurück"
                severity="secondary"
                icon="pi pi-arrow-left"
                @click="prevCallback"
              />
              <Button
                label="Weiter"
                icon="pi pi-arrow-right"
                iconPos="right"
                :disabled="wizardBusy"
                @click="stepIsValid(nextCallback)"
              />
            </div>
          </template>
        </StepperPanel>
        <StepperPanel header="Abschluss">
          <template #header="{ index, clickCallback }">
            <button
              class="p-stepper-action custom-stepper-class"
              role="tab"
              @click="navigateStep(index, clickCallback)"
            >
              <div class="flex flex-column align-items-center justify-content-center">
                <span
                  class="p-stepper-number"
                  style="width: 2rem"
                  data-pc-section="number"
                  >{{ index + 1 }}</span
                ><span class="p-stepper-title" data-pc-section="title">Abschluss</span>
              </div>
            </button>
          </template>
          <template #content="{ prevCallback }">
            <div class="flex flex-column h-12rem" style="max-width: 1400px">
              <Card>
                <template #title>Verein</template>
                <template #content>
                  <div
                    class="flex flex-wrap align-items-center justify-content-center"
                    v-if="selectedAssociation && associationUnlocked"
                  >
                    <div
                      v-for="field in associationFields"
                      v-bind:key="field.id"
                      class="field grid"
                      style="margin: 5px 2px; width: 100%; max-width: 480px"
                    >
                      <label class="col-fixed custom-input-label" style="width: 180px">{{
                        field.label
                      }}</label>
                      <div class="col">
                        <InputText
                          style="width: 100%; color: black"
                          v-model="selectedAssociation[field.id]"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="selectedAssociation"
                    class="flex flex-column align-items-center justify-content-center"
                  >
                    <div
                      class="field grid"
                      style="margin: 5px 2px; width: 100%; max-width: 480px"
                    >
                      <label class="col-fixed custom-input-label" style="width: 180px"
                        >Name</label
                      >
                      <div class="col">
                        <InputText
                          style="width: 100%; color: black"
                          v-model="selectedAssociation.name"
                          disabled
                        />
                      </div>
                    </div>
                    <Message
                      severity="info"
                      :closable="false"
                      style="margin-top: 8px; max-width: 480px"
                      >Die hinterlegten Vereinsdaten werden unverändert übernommen.</Message
                    >
                  </div>
                </template>
              </Card>
              <Card>
                <template #title>Mannschaft</template>
                <template #content
                  ><div
                    class="flex flex-wrap align-items-center justify-content-center"
                    v-if="selectedTeam"
                  >
                    <div
                      v-for="field in teamFields"
                      v-bind:key="field.id"
                      class="field grid"
                      style="margin: 5px 2px; width: 100%; max-width: 480px"
                    >
                      <label
                        class="col-fixed custom-input-label"
                        style="width: 180px; text-align: left"
                        >{{ field.label }}</label
                      >
                      <div class="col">
                        <InputText
                          v-if="field.convert"
                          style="width: 100%; color: black"
                          :value="field.convert(selectedTeam[field.id])"
                          disabled
                        />
                        <InputText
                          v-else
                          style="width: 100%; color: black"
                          v-model="selectedTeam[field.id]"
                          disabled
                        />
                      </div>
                    </div></div
                ></template>
              </Card>
              <Card>
                <template #title>Spielstätte</template>
                <template #content>
                  <div class="flex flex-wrap align-items-center justify-content-center">
                    <div
                      v-for="field in locationFields"
                      v-bind:key="field.id"
                      class="field grid"
                      style="margin: 5px 2px; width: 100%; max-width: 480px"
                    >
                      <label
                        class="col-fixed custom-input-label"
                        style="width: 180px; text-align: left"
                        >{{ field.label }}</label
                      >
                      <div class="col">
                        <InputText
                          v-if="field.convert"
                          style="width: 100%; color: black"
                          :value="field.convert(selectedLocation[field.id])"
                          disabled
                        />
                        <InputText
                          v-else
                          style="width: 100%; color: black"
                          v-model="selectedLocation[field.id]"
                          disabled
                        />
                      </div>
                    </div></div
                ></template>
              </Card>
              <Card>
                <template #title>Wünsche</template>
                <template #content>
                  <DataTable
                    v-if="teamCriterias.length > 0"
                    class="p-datatable-sm"
                    :value="teamCriterias"
                    stripedRows
                    responsiveLayout="stack"
                    breakpoint="550px"
                  >
                    <Column field="type" header="Art">
                      <template #body="{ data }">
                        <span>{{ getLabelForCriteriaType(data) }}</span>
                      </template>
                    </Column>
                  </DataTable>
                  <div v-else>Keine Wünsche / Bedingungen erfasst.</div>
                </template>
              </Card>

              <Message
                v-if="teamRegistrationError && teamRegistrationError.length > 0"
                severity="error"
                :closable="false"
                style="margin-top: 12px"
                >{{ teamRegistrationError }}</Message
              >

              <div class="flex pt-4 justify-content-between">
                <Button
                  label="Zurück"
                  severity="secondary"
                  icon="pi pi-arrow-left"
                  @click="prevCallback"
                />
                <Button
                  label="Anmeldung abschließen"
                  icon="pi pi-arrow-right"
                  iconPos="right"
                  :disabled="wizardBusy"
                  @click="finishRegistration"
                />
              </div>
            </div>
          </template>
        </StepperPanel>
      </Stepper>
    </div>
    <Dialog
      id="criteriaDialog"
      modal
      v-model:visible="displayCriteriaDialog"
      :closable="true"
    >
      <template #header>
        <div
          class="align-items-center justify-content-center"
          style="font-size: 20px; text-align: center; width: 100%"
        >
          Bedingung / Wunsch bearbeiten
        </div>
      </template>
      <div class="flex flex-column">
        <div class="flex align-items-center justify-content-center">
          <Dropdown
            v-model="selectedTeamCriteriaFieldDescription"
            :options="currentTeamPreSeasonTeamCriteriaFieldDescriptions"
            optionLabel="label"
            placeholder="Bedingung / Wunsch auswählen"
            style="width: 350px"
            @change="selectedTeamCriteriaFieldDescriptionChanged()"
          ></Dropdown>
        </div>
        <div
          class="flex align-items-center justify-content-center"
          style="max-width: 420px; margin: 12px auto 0; color: #6c757d; font-size: 0.9em; text-align: center"
        >
          Wählen Sie die passende Bedingung bzw. den passenden Wunsch aus. Sollte
          keine der vorgegebenen Möglichkeiten zu Ihrem Anliegen passen, wählen Sie
          die letzte Option „Sonstiger Wunsch (frei formuliert)“ und beschreiben Sie
          Ihren Wunsch in eigenen Worten.
        </div>
        <!-- Freitext-Wunsch: eigenes Textfeld statt der generischen Feld-Eingaben. -->
        <div
          v-if="
            selectedTeamCriteriaFieldDescription &&
            selectedTeamCriteriaFieldDescription.type === freeTextCriteriaType
          "
          class="flex flex-column align-items-center justify-content-center"
          style="width: 100%"
        >
          <div class="flex flex-column" style="margin-top: 20px; width: 100%; max-width: 420px">
            <label class="custom-input-label" style="margin-bottom: 4px">Ihr Wunsch</label>
            <Textarea
              v-model="currentTeamCriteria.text"
              :autoResize="true"
              rows="4"
              :maxlength="2048"
              style="width: 100%"
              placeholder="Beschreiben Sie hier Ihren Wunsch, der sich nicht über die obige Auswahl abbilden lässt."
            />
          </div>
        </div>
        <div
          v-else-if="
            selectedTeamCriteriaFieldDescription &&
            selectedTeamCriteriaFieldDescription.type
          "
          class="flex flex-column align-items-center justify-content-center"
        >
          <div class="flex flex-column" style="margin-top: 20px">
            <div
              class="flex align-items-center justify-content-center"
              v-for="recordFieldDescription in selectedTeamCriteriaFieldDescription.fieldDescriptions"
              v-bind:key="recordFieldDescription.name"
            >
              <RecordField
                v-model:record="currentTeamCriteria"
                :recordFieldDescription="recordFieldDescription"
                :editMode="true"
                :minWidth="300"
              />
            </div>
          </div>
        </div>
        <div v-else></div>
      </div>
      <template #footer>
        <div class="flex justify-content-between flex-wrap card-container">
          <Button label="Abbrechen" @click="closeCriteriaDialog(false)" />
          <Button label="Speichern" @click="closeCriteriaDialog(true)" />
        </div>
      </template>
    </Dialog>
    <Dialog v-model:visible="showDeleteCriteriaDialog" :closable="false">
      <template #header>
        <h3>Bedingung oder Wunsch löschen</h3>
      </template>

      Soll die Bedingung / Wunsch "{{ getLabelForCriteriaType(currentTeamCriteria) }}"
      wirklich gelöscht werden?

      <template #footer>
        <Button
          label="Löschen"
          icon="pi pi-trash"
          class="p-button-text"
          @click="closeDeleteCriteriaDialog(true)"
        />
        <Button
          label="Abbrechen"
          icon="pi pi-check"
          @click="closeDeleteCriteriaDialog(false)"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ServerConnection from "../../services/ServerConnection/ServerConnection";
import Stepper from "primevue/stepper";
import StepperPanel from "primevue/stepperpanel";
import Button from "primevue/button";
import SelectButton from "primevue/selectbutton";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import Message from "primevue/message";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dialog from "primevue/dialog";
import RecordField from "../records/RecordField";
import Card from "primevue/card";

const STEP_VEREIN = 0;
const STEP_MANNSCHAFT = 1;
const STEP_SPIELSTAETTE = 2;
// STEP_WUENSCHE = 3 (optional, keine Validierung)
// STEP_ABSCHLUSS = 4 (Submit)

// Spezieller Kriterien-Typ für den frei formulierten Wunsch. Wird im Dropdown als
// letzte Auswahlmöglichkeit angeboten und beim Absenden in das Freitextfeld
// (criteriaNotes) der Anmeldung überführt, statt als reguläres Kriterium.
const FREE_TEXT_CRITERIA_TYPE = "FreeText";

export default {
  name: "TeamRegistration",
  components: {
    Stepper,
    StepperPanel,
    Button,
    SelectButton,
    Dropdown,
    InputText,
    Textarea,
    Message,
    DataTable,
    Column,
    Dialog,
    RecordField,
    Card,
  },
  created() {
    this.loadRegistrationStatus();
  },
  watch: {
    // Sobald der Wizard sichtbar wird, einen zusätzlichen History-Eintrag
    // anlegen, damit der Browser-Zurück-Button abgefangen werden kann.
    wizardActive(active) {
      if (active) {
        this.pushHistoryGuard();
      }
    },
  },
  computed: {
    booleanOptions() {
      return [
        { name: "Ja", value: true },
        { name: "Nein", value: false },
      ];
    },
    smokingOptions() {
      return [
        { name: "Raucher", value: "smoking" },
        { name: "Nichtraucher", value: "nonSmoking" },
        { name: "Nichtraucher auf Anfrage", value: "nonSmokingIfRequested" },
      ];
    },
    // Wahr, solange der Stepper sichtbar ist (also nicht im Bot-Check, in der
    // Eingangsauswahl oder auf der Abschluss-Seite). Steuert das Abfangen des
    // Browser-Zurück-Buttons.
    wizardActive() {
      return (
        this.noBotCheckPassed &&
        this.entryChoiceMade &&
        !this.registrationSubmitted
      );
    },
  },
  data() {
    return {
      registrationStatusLoaded: false,
      registrationClosed: false,
      registrationClosedMessage: "Die Anmeldefrist ist abgelaufen!",
      noBotCheckPassed: false,
      noBotCheckNumber: 0,
      noBotCheckValue: "",
      noBotCheckError: "",
      activeStep: 0,
      teamRegistrationError: "",
      registrationSubmitted: false,
      entryChoiceMade: false,
      resumeIdInput: "",
      resumeError: "",
      entryError: "",
      draftId: null,
      wizardBusy: false,
      associations: [],
      selectedAssociation: {},
      associationUnlocked: false,
      bwdvNumberInput: "",
      associationUnlockError: "",
      newOrOldTeamSelected: false,
      newTeam: false,
      teams: [],
      selectedTeam: {},
      newOrOldLocationSelected: false,
      newLocation: false,
      locations: [],
      selectedLocation: {},
      criteriaFieldDescriptions: [],
      currentTeamPreSeasonTeamCriteriaFieldDescriptions: [],
      selectedTeamCriteriaFieldDescription: {},
      teamCriterias: [],
      currentTeamCriteria: {},
      criteriaNotes: "",
      freeTextCriteriaType: FREE_TEXT_CRITERIA_TYPE,
      // Synthetische Auswahlmöglichkeit für den Freitext-Wunsch (immer als letzte
      // Option im Dropdown).
      freeTextCriteriaDescription: {
        type: FREE_TEXT_CRITERIA_TYPE,
        label: "Sonstiger Wunsch (frei formuliert)",
        defaultPriority: 0,
        multipleAllowed: false,
        fieldDescriptions: [{ name: "text", label: "Wunsch", fieldType: "String" }],
      },
      displayCriteriaDialog: false,
      showDeleteCriteriaDialog: false,
      editingCriteriaIndex: null,
      associationFields: [
        { id: "bwdvNumber", label: "BWDV-Nummer" },
        { id: "name", label: "Name" },
        { id: "sportbundNumber", label: "Mitgliedsnr. Sportbund" },
        { id: "chairmanName", label: "Vorstand" },
        { id: "street", label: "Strasse" },
        { id: "plz", label: "PLZ" },
        { id: "city", label: "Stadt" },
        { id: "email", label: "E-Mail" },
      ],
      teamFields: [
        { id: "name", label: "Name" },
        { id: "contactPersonName", label: "Name Teamvertreter" },
        { id: "contactPersonEMail", label: "E-Mail Teamvertreter" },
        { id: "contactPersonPhone", label: "Telefonnummer Teamvertreter" },
        {
          id: "registeredForCup",
          label: "Pokal-Teilnahme",
          convert: (v) => this.nameFromOptions(this.booleanOptions, v),
        },
      ],
      locationFields: [
        { id: "name", label: "Name" },
        { id: "street", label: "Strasse" },
        { id: "plz", label: "PLZ" },
        { id: "city", label: "Stadt" },
        { id: "numberOfBoards", label: "Anzahl Boards" },
        {
          id: "smokingType",
          label: "Rauchen",
          convert: (v) => this.nameFromOptions(this.smokingOptions, v),
        },
        {
          id: "youthAllowed",
          label: "Jugend erlaubt",
          convert: (v) => this.nameFromOptions(this.booleanOptions, v),
        },
      ],
    };
  },
  props: {},
  methods: {
    finishRegistration() {
      if (this.wizardBusy) {
        return;
      }
      this.teamRegistrationError = "";
      // Freitext-Wunsch separat als criteriaNotes uebertragen und nicht als
      // regulaeres Kriterium (das der Spielplan-Algorithmus nicht kennt).
      var freeTextCriteria = this.teamCriterias.find(
        (c) => c.type === this.freeTextCriteriaType
      );
      var realCriterias = this.teamCriterias.filter(
        (c) => c.type !== this.freeTextCriteriaType
      );
      var payload = {
        association: this.selectedAssociation,
        team: {
          ...this.selectedTeam,
          existingTeamId: this.newTeam ? null : this.selectedTeam.existingTeamId,
        },
        location: this.selectedLocation,
        criterias: realCriterias.map((c) => ({
          type: c.type,
          parameters: c.parameters,
          priority: c.priority,
        })),
        criteriaNotes: freeTextCriteria ? freeTextCriteria.text || "" : "",
      };
      payload.draftId = this.draftId;
      this.wizardBusy = true;
      ServerConnection.post("teamregistration/submit", payload)
        .then(() => {
          this.wizardBusy = false;
          this.registrationSubmitted = true;
        })
        .catch((error) => {
          this.wizardBusy = false;
          this.teamRegistrationError = this.formatError(error);
        });
    },
    startNewRegistration() {
      if (this.wizardBusy) {
        return;
      }
      this.entryError = "";
      this.wizardBusy = true;
      this.saveDraft()
        .then(() => {
          this.wizardBusy = false;
          this.entryChoiceMade = true;
        })
        .catch((error) => {
          this.wizardBusy = false;
          this.entryError =
            this.formatError(error) || "Anmeldung konnte nicht gestartet werden";
        });
    },
    saveDraft() {
      var payload = JSON.stringify({
        activeStep: this.activeStep,
        newOrOldTeamSelected: this.newOrOldTeamSelected,
        newTeam: this.newTeam,
        newOrOldLocationSelected: this.newOrOldLocationSelected,
        newLocation: this.newLocation,
        selectedAssociation: this.selectedAssociation,
        associationUnlocked: this.associationUnlocked,
        selectedTeam: this.selectedTeam,
        selectedLocation: this.selectedLocation,
        teamCriterias: this.teamCriterias,
        criteriaNotes: this.criteriaNotes,
      });
      return ServerConnection.post("teamregistration/draft", {
        draftId: this.draftId,
        payload: payload,
      }).then((response) => {
        this.draftId = response.data.draftId;
      });
    },
    loadDraft() {
      if (this.wizardBusy) {
        return;
      }
      this.resumeError = "";
      this.wizardBusy = true;
      ServerConnection.get(
        "teamregistration/draft/" + encodeURIComponent(this.resumeIdInput)
      )
        .then((response) => {
          var data = response.data;
          var state;
          try {
            state = JSON.parse(data.payload);
          } catch (e) {
            this.wizardBusy = false;
            this.resumeError =
              "Die gespeicherten Daten sind beschädigt. Bitte den Support kontaktieren.";
            return;
          }
          this.draftId = data.draftId;
          this.selectedAssociation = state.selectedAssociation || {};
          // Freischaltung nur wiederherstellen, wenn die zuvor freigeschalteten
          // Daten (inkl. BWDV-Nummer) im Entwurf tatsaechlich vorhanden sind.
          this.associationUnlocked =
            !!state.associationUnlocked &&
            !!(state.selectedAssociation && state.selectedAssociation.bwdvNumber);
          this.bwdvNumberInput = "";
          this.associationUnlockError = "";
          this.selectedTeam = state.selectedTeam || {};
          this.selectedLocation = state.selectedLocation || {};
          this.teamCriterias = state.teamCriterias || [];
          this.criteriaNotes = state.criteriaNotes || "";
          // Aeltere Entwuerfe haben den Freitext noch in criteriaNotes statt als
          // Kriterium. In eine Freitext-Zeile umwandeln, falls noch keine existiert.
          if (
            this.criteriaNotes &&
            this.criteriaNotes.trim().length > 0 &&
            !this.teamCriterias.some((c) => c.type === this.freeTextCriteriaType)
          ) {
            this.teamCriterias.push({
              type: this.freeTextCriteriaType,
              text: this.criteriaNotes,
              parameters: "text=" + encodeURIComponent(this.criteriaNotes),
              priority: 0,
            });
          }
          this.criteriaNotes = "";
          this.newOrOldTeamSelected = !!state.newOrOldTeamSelected;
          this.newTeam = !!state.newTeam;
          this.newOrOldLocationSelected = !!state.newOrOldLocationSelected;
          this.newLocation = !!state.newLocation;
          if (this.selectedAssociation && this.selectedAssociation.id) {
            this.loadTeams();
          }
          this.activeStep = state.activeStep || 0;
          this.entryChoiceMade = true;
          this.wizardBusy = false;
        })
        .catch((error) => {
          this.wizardBusy = false;
          this.resumeError =
            this.formatError(error) || "Anmeldungs-ID unbekannt oder abgelaufen";
        });
    },
    resetRegistration() {
      this.registrationSubmitted = false;
      this.activeStep = 0;
      this.teamRegistrationError = "";
      this.selectedAssociation = {};
      this.associationUnlocked = false;
      this.bwdvNumberInput = "";
      this.associationUnlockError = "";
      this.newOrOldTeamSelected = false;
      this.newTeam = false;
      this.teams = [];
      this.selectedTeam = {};
      this.newOrOldLocationSelected = false;
      this.newLocation = false;
      this.selectedLocation = {};
      this.teamCriterias = [];
      this.criteriaNotes = "";
      this.currentTeamPreSeasonTeamCriteriaFieldDescriptions = this.criteriaFieldDescriptions;
      this.entryChoiceMade = false;
      this.resumeIdInput = "";
      this.resumeError = "";
      this.entryError = "";
      this.draftId = null;
    },
    validateStep() {
      if (this.activeStep === STEP_VEREIN) {
        if (!this.selectedAssociation || !this.selectedAssociation.id) {
          this.teamRegistrationError = "Bitte zunächst einen Verein auswählen";
          return false;
        }
        // Vereinsdaten nur dann auf Vollständigkeit prüfen, wenn sie zum Bearbeiten
        // freigeschaltet wurden. Ohne Freischaltung ist eine Meldung trotzdem möglich.
        if (
          this.associationUnlocked &&
          this.missingFieldValuesExist(this.selectedAssociation, [
            "chairmanName",
            "plz",
            "street",
            "city",
            "email",
          ])
        ) {
          this.teamRegistrationError =
            "Bitte alle Felder ausfüllen und mit Klick auf 'Weiter' fortfahren";
          return false;
        }
      } else if (this.activeStep === STEP_MANNSCHAFT) {
        if (!this.selectedTeam || !this.selectedTeam.name) {
          this.teamRegistrationError = "Bitte zunächst eine Auswahl treffen";
          return false;
        }
        if (
          this.missingFieldValuesExist(this.selectedTeam, [
            "name",
            "contactPersonName",
            "contactPersonEMail",
            "contactPersonPhone",
            "registeredForCup",
          ])
        ) {
          this.teamRegistrationError =
            "Bitte alle Felder ausfüllen und mit Klick auf 'Weiter' fortfahren";
          return false;
        }
      } else if (this.activeStep === STEP_SPIELSTAETTE) {
        if (!this.selectedLocation || !this.selectedLocation.name) {
          this.teamRegistrationError = "Bitte zunächst eine Auswahl treffen";
          return false;
        }
        if (
          this.missingFieldValuesExist(this.selectedLocation, [
            "name",
            "plz",
            "street",
            "city",
            "numberOfBoards",
            "smokingType",
            "youthAllowed",
          ])
        ) {
          this.teamRegistrationError =
            "Bitte alle Felder ausfüllen und mit Klick auf 'Weiter' fortfahren";
          return false;
        }
      }
      // STEP_WUENSCHE ist bewusst optional, deshalb keine Validierung.
      this.teamRegistrationError = "";
      return true;
    },
    stepIsValid(func) {
      if (this.wizardBusy) {
        return;
      }
      if (!this.validateStep()) {
        return;
      }
      this.wizardBusy = true;
      // Vereinsdaten nur speichern, wenn sie zum Bearbeiten freigeschaltet wurden.
      // Ohne Freischaltung bleiben die hinterlegten Daten unverändert.
      var pre =
        this.activeStep === STEP_VEREIN && this.associationUnlocked
          ? this.saveAssociation()
          : Promise.resolve();
      pre
        .then(() => this.saveDraft())
        .then(() => {
          this.wizardBusy = false;
          func();
        })
        .catch((error) => {
          this.wizardBusy = false;
          this.teamRegistrationError =
            this.formatError(error) || "Daten konnten nicht gespeichert werden";
        });
    },
    saveAssociation() {
      return ServerConnection.post(
        "teamregistration/association",
        this.selectedAssociation
      );
    },
    navigateStep(targetIndex, clickCallback) {
      if (targetIndex > this.activeStep) {
        this.stepIsValid(clickCallback);
      } else {
        clickCallback();
      }
    },
    pushHistoryGuard() {
      // Zusätzlichen History-Eintrag ohne URL-Änderung anlegen. Der vorhandene
      // vue-router-State wird dabei beibehalten. Ein nachfolgender Klick auf
      // den Browser-Zurück-Button löst dann handleBrowserBack aus, statt den
      // Wizard ganz zu verlassen.
      window.history.pushState(
        { ...window.history.state, teamRegistrationGuard: true },
        ""
      );
    },
    handleBrowserBack() {
      if (!this.wizardActive) {
        return;
      }
      this.goToPreviousWizardStep();
      if (this.wizardActive) {
        // Noch im Wizard – Guard für den nächsten Zurück-Klick neu setzen.
        this.pushHistoryGuard();
      }
    },
    goToPreviousWizardStep() {
      this.teamRegistrationError = "";
      if (this.activeStep > 0) {
        this.activeStep = this.activeStep - 1;
      } else {
        // Erster Schritt – zurück zur Eingangsauswahl.
        this.entryChoiceMade = false;
      }
    },
    missingFieldValuesExist(object, fieldNames) {
      for (var fieldName of fieldNames) {
        var value = object[fieldName];
        if (value == null) {
          return true;
        }
        if (typeof value === "string" && value.trim() === "") {
          return true;
        }
      }
      return false;
    },
    loadRegistrationStatus() {
      ServerConnection.get("teamregistration/status")
        .then((response) => response.data)
        .then((data) => {
          this.registrationClosed = !!(data && data.registrationClosed);
          if (data && data.message && data.message.length > 0) {
            this.registrationClosedMessage = data.message;
          }
          this.registrationStatusLoaded = true;
          if (!this.registrationClosed) {
            this.loadNotBotCheckNumber();
          }
        })
        .catch((error) => {
          this.registrationStatusLoaded = true;
          var message = this.formatError(error);
          if (!this.registrationClosed) {
            this.noBotCheckError = message;
            this.loadNotBotCheckNumber();
          }
        });
    },
    loadNotBotCheckNumber() {
      if (!this.noBotCheckPassed && this.noBotCheckNumber <= 0) {
        ServerConnection.get("teamregistration/nobotcheck/number")
          .then((response) => response.data)
          .then((data) => {
            this.noBotCheckNumber = data;
          })
          .catch((error) => {
            this.noBotCheckError = this.formatError(error);
          });
      }
    },
    checkNotBotCheck() {
      ServerConnection.put("teamregistration/nobotcheck/check", this.noBotCheckValue)
        .then(() => {
          this.noBotCheckPassed = true;
          this.loadAssociations();
          this.loadLocations();
          this.loadCriteriaFieldDescriptions();
        })
        .catch((error) => {
          this.noBotCheckError = this.formatError(error);
        });
    },
    loadAssociations() {
      if (this.noBotCheckPassed && this.associations.length <= 0) {
        ServerConnection.get("teamregistration/associations")
          .then((response) => response.data)
          .then((data) => {
            this.associations = data;
          })
          .catch((error) => {
            this.teamRegistrationError = this.formatError(error);
          });
      }
    },
    onAssociationChange() {
      // Verein-Wechsel: Freischaltung der Vereinsdaten zuruecksetzen, damit fuer den
      // neu gewaehlten Verein zum Bearbeiten erneut die BWDV-Nummer abgefragt wird.
      // Die Teams werden direkt geladen, da die Meldung auch ohne Freischaltung der
      // Vereinsdaten moeglich sein soll.
      this.associationUnlocked = false;
      this.bwdvNumberInput = "";
      this.associationUnlockError = "";
      this.loadTeams();
    },
    unlockAssociation() {
      if (this.wizardBusy) {
        return;
      }
      this.associationUnlockError = "";
      if (
        !this.selectedAssociation ||
        !this.selectedAssociation.id ||
        !this.bwdvNumberInput
      ) {
        return;
      }
      this.wizardBusy = true;
      ServerConnection.post(
        "teamregistration/association/" +
          this.selectedAssociation.id +
          "/unlock",
        this.bwdvNumberInput
      )
        .then((response) => response.data)
        .then((data) => {
          // Vollstaendige Vereinsdaten in das ausgewaehlte Objekt uebernehmen,
          // ohne die Referenz zu ersetzen (sonst feuert das Dropdown @change).
          Object.assign(this.selectedAssociation, data);
          this.associationUnlocked = true;
          this.wizardBusy = false;
          this.saveDraft().catch(() => {});
        })
        .catch((error) => {
          this.wizardBusy = false;
          this.associationUnlockError =
            this.formatError(error) || "Die BWDV-Nummer ist nicht korrekt";
        });
    },
    loadTeams() {
      if (
        this.noBotCheckPassed &&
        this.selectedAssociation &&
        this.selectedAssociation.id
      ) {
        // Verein-Wechsel: alte Team-Auswahl + abhaengige Spielstaette zuruecksetzen,
        // damit kein zur neuen Association nicht passendes Team gespeichert wird.
        var requestedAssociationId = this.selectedAssociation.id;
        if (
          this.selectedTeam &&
          this.selectedTeam.id &&
          (!this.teams.length ||
            !this.teams.some((t) => t.id === this.selectedTeam.id))
        ) {
          this.selectedTeam = {};
          this.newOrOldTeamSelected = false;
          this.newTeam = false;
          this.selectedLocation = {};
          this.newOrOldLocationSelected = false;
          this.newLocation = false;
        }
        this.validateStep();
        ServerConnection.get(
          "teamregistration/association/" + requestedAssociationId + "/teams"
        )
          .then((response) => response.data)
          .then((data) => {
            if (
              this.selectedAssociation &&
              this.selectedAssociation.id === requestedAssociationId
            ) {
              this.teams = data;
            }
          })
          .catch((error) => {
            this.teamRegistrationError = this.formatError(error);
          });
      }
    },
    loadLocations() {
      if (this.noBotCheckPassed && this.locations.length <= 0) {
        ServerConnection.get("teamregistration/locations")
          .then((response) => response.data)
          .then((data) => {
            this.locations = data;
          })
          .catch((error) => {
            this.teamRegistrationError = this.formatError(error);
          });
      }
    },
    loadCriteriaFieldDescriptions() {
      if (this.noBotCheckPassed && this.criteriaFieldDescriptions.length <= 0) {
        ServerConnection.get("teamregistration/criteriaFieldDescriptions")
          .then((response) => response.data)
          .then((data) => {
            // Freitext-Wunsch immer als letzte Auswahlmöglichkeit ergänzen.
            var withFreeText = data.concat([this.freeTextCriteriaDescription]);
            this.criteriaFieldDescriptions = withFreeText;
            this.currentTeamPreSeasonTeamCriteriaFieldDescriptions = withFreeText;
          })
          .catch((error) => {
            this.teamRegistrationError = this.formatError(error);
          });
      }
    },
    addCriteria() {
      this.currentTeamCriteria = {};
      this.selectedTeamCriteriaFieldDescription = {};
      this.editingCriteriaIndex = null;
      this.displayCriteriaDialog = true;
    },
    editCriteria(criteria) {
      var fieldDescriptions = this.criteriaFieldDescriptions.filter(
        (fd) => fd.type == criteria.type
      );
      if (fieldDescriptions && fieldDescriptions.length > 0) {
        this.selectedTeamCriteriaFieldDescription = fieldDescriptions[0];
      }
      // Auf einer Kopie editieren, damit ein Abbruch die Liste nicht mutiert.
      this.currentTeamCriteria = { ...criteria };
      this.editingCriteriaIndex = this.teamCriterias.indexOf(criteria);
      this.displayCriteriaDialog = true;
    },
    closeCriteriaDialog(saved) {
      if (
        saved &&
        this.selectedTeamCriteriaFieldDescription &&
        this.selectedTeamCriteriaFieldDescription.type
      ) {
        this.currentTeamCriteria.type = this.selectedTeamCriteriaFieldDescription.type;
        var parameters = "";
        this.selectedTeamCriteriaFieldDescription.fieldDescriptions.forEach((fd) => {
          var value = this.currentTeamCriteria[fd.name];
          if (value != null && String(value).length > 0) {
            if (parameters.length > 0) {
              parameters += ",";
            }
            // Werte URL-encoden, damit Kommas/Gleichheitszeichen im Wert das
            // "key=value,key=value"-Format nicht brechen.
            parameters += fd.name + "=" + encodeURIComponent(String(value));
          }
        });
        this.currentTeamCriteria.parameters = parameters;

        if (this.editingCriteriaIndex != null && this.editingCriteriaIndex >= 0) {
          // Bestehendes Kriterium aktualisieren.
          this.teamCriterias.splice(this.editingCriteriaIndex, 1, this.currentTeamCriteria);
        } else {
          // Duplikat nur bei wirklich identischem Eintrag verhindern.
          var existingCriteria = this.teamCriterias.find(
            (tc) =>
              tc.type === this.currentTeamCriteria.type &&
              tc.parameters === this.currentTeamCriteria.parameters
          );
          if (!existingCriteria) {
            this.teamCriterias.push(this.currentTeamCriteria);
          }
        }
        this.teamCriterias.sort((a, b) => b.priority - a.priority);

        var selectedType = this.selectedTeamCriteriaFieldDescription.type;
        this.currentTeamPreSeasonTeamCriteriaFieldDescriptions = this.currentTeamPreSeasonTeamCriteriaFieldDescriptions.filter(
          (item) => item.type !== selectedType || item.multipleAllowed
        );
      }
      this.editingCriteriaIndex = null;
      this.displayCriteriaDialog = false;
    },
    deleteCriteria(criteria) {
      this.currentTeamCriteria = criteria;
      this.showDeleteCriteriaDialog = true;
    },
    closeDeleteCriteriaDialog(deleted) {
      this.showDeleteCriteriaDialog = false;
      if (deleted) {
        this.teamCriterias = this.teamCriterias.filter(
          (item) => item !== this.currentTeamCriteria
        );
        this.currentTeamPreSeasonTeamCriteriaFieldDescriptions = this.criteriaFieldDescriptions.filter(
          (tcfd) => {
            if (tcfd.multipleAllowed) {
              return true;
            }
            var found = this.teamCriterias.find((tc) => tc.type == tcfd.type);
            return !found || found.length <= 0;
          }
        );
      }
    },
    selectedTeamCriteriaFieldDescriptionChanged() {
      if (!this.currentTeamCriteria.id) {
        this.currentTeamCriteria.priority = this.selectedTeamCriteriaFieldDescription.defaultPriority;
        if (this.selectedTeamCriteriaFieldDescription.defaultValues) {
          var dv = this.selectedTeamCriteriaFieldDescription.defaultValues;
          this.selectedTeamCriteriaFieldDescription.fieldDescriptions.forEach((fd) => {
            if (dv[fd.name] && dv[fd.name].length > 0) {
              this.currentTeamCriteria[fd.name] = dv[fd.name];
            }
          });
        }
      }
    },
    getLabelForCriteriaType(criteria) {
      var fieldDescriptions = this.criteriaFieldDescriptions.filter(
        (fd) => fd.type == criteria.type
      );
      if (fieldDescriptions && fieldDescriptions.length > 0) {
        return (
          fieldDescriptions[0].label +
          this.getParameterLabelForCriteria(criteria, fieldDescriptions[0])
        );
      }
      return "Unbekannt";
    },
    getParameterLabelForCriteria(criteria, fieldDescription) {
      var paramLabel = "";
      fieldDescription.fieldDescriptions.forEach((fd) => {
        if (criteria[fd.name] && criteria[fd.name].length > 0) {
          if (fd.fieldType == "Enum") {
            var enumValue = fd.enumValues.find(
              (enumValue) => enumValue.value == criteria[fd.name]
            );
            if (enumValue && enumValue.value) {
              if (paramLabel.length > 0) {
                paramLabel += ", ";
              }
              paramLabel += enumValue.label;
            }
          } else if (fd.fieldType == "Date") {
            var value = new Date(criteria[fd.name]);
            var day = value.getDate();
            var month = value.getMonth() + 1;
            var year = value.getFullYear();
            if (paramLabel.length > 0) {
              paramLabel += ", ";
            }
            paramLabel +=
              (day < 10 ? "0" + day : day) +
              "." +
              (month < 10 ? "0" + month : month) +
              "." +
              year;
          } else {
            if (paramLabel.length > 0) {
              paramLabel += ", ";
            }
            paramLabel += criteria[fd.name];
          }
        }
      });
      if (paramLabel.length > 0) {
        return " (" + paramLabel + ")";
      }
      return paramLabel;
    },
    nameFromOptions(options, v) {
      if (options && options.length > 0 && v != null) {
        var option = options.find((o) => o.value == v);
        return option ? option.name : "Keine";
      }
      return "Keine";
    },
    copyDraftId() {
      if (!this.draftId) {
        return;
      }
      var fallback = () => {
        try {
          var ta = document.createElement("textarea");
          ta.value = this.draftId;
          ta.style.position = "fixed";
          ta.style.opacity = "0";
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        } catch (e) {
          // ignore, user kann ID weiterhin manuell selektieren
        }
      };
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.draftId).catch(fallback);
      } else {
        fallback();
      }
    },
    resetToNoBotCheck() {
      // Server-Session hat die No-Bot-Bestaetigung (checkPassed) verloren, z. B.
      // durch Session-Timeout. Zurueck zur No-Bot-Pruefung springen, dabei aber
      // die bereits erfassten Wizard-Daten (Verein, Team, Spielstaette, Kriterien,
      // draftId und aktueller Schritt) bewusst NICHT zuruecksetzen. Nach erneut
      // geloester Pruefung landet der Nutzer wieder auf demselben Schritt.
      if (!this.noBotCheckPassed) {
        return;
      }
      this.noBotCheckPassed = false;
      this.noBotCheckValue = "";
      this.noBotCheckNumber = 0;
      this.teamRegistrationError = "";
      this.wizardBusy = false;
      this.noBotCheckError =
        "Ihre Sitzung ist abgelaufen. Bitte lösen Sie die Aufgabe erneut – Ihre Eingaben bleiben erhalten.";
      this.loadNotBotCheckNumber();
    },
    formatError(error) {
      if (error && error.response && error.response.status === 410) {
        this.registrationClosed = true;
        if (typeof error.response.data === "string" && error.response.data.length > 0) {
          this.registrationClosedMessage = error.response.data;
        }
        return "";
      }
      if (
        error &&
        error.response &&
        error.response.status === 403 &&
        error.response.data === "NOBOT_REQUIRED"
      ) {
        // Zentrale Behandlung des Session-Gate-403 (siehe NOBOT_REQUIRED_MARKER
        // im TeamRegistrationController). Gilt fuer alle abgesicherten Endpunkte.
        this.resetToNoBotCheck();
        return "";
      }
      if (error && error.response && error.response.data) {
        var data = error.response.data;
        if (typeof data === "string" && data.length > 0) {
          return data;
        }
      }
      if (error && error.message) {
        return error.message;
      }
      return "Unbekannter Fehler";
    },
    onBeforeUnload(event) {
      if (
        this.entryChoiceMade &&
        !this.registrationSubmitted &&
        !this.registrationClosed &&
        !this.wizardBusy
      ) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
  },
  mounted() {
    window.addEventListener("beforeunload", this.onBeforeUnload);
    window.addEventListener("popstate", this.handleBrowserBack);
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
    window.removeEventListener("popstate", this.handleBrowserBack);
  },
};
</script>

<style lang="css">
.bdl-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--surface-border, #dee2e6);
  border-radius: 6px;
  background: var(--surface-overlay, #fff);
  color: var(--text-color, #495057);
  font-size: 1rem;
  outline: none;
}
.bdl-input:focus {
  border-color: var(--primary-color, #2196f3);
}
.bdl-input:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  color: #6c757d;
}
@media only screen and (max-width: 550px) {
  .custom-input-label {
    width: 100% !important;
  }
  .custom-stepper-class {
    display: block;
    padding: 0px;
  }
  .p-stepper .p-stepper-panels {
    padding: 0px !important;
  }
  .p-stepper .p-stepper-header {
    padding: 0px !important;
  }
  .p-stepper .p-stepper-header .p-stepper-action .p-stepper-title {
    margin-left: 0px !important;
  }
}
</style>
